import { render, staticRenderFns } from "./CbsSpinner.vue?vue&type=template&id=4844acfd&scoped=true"
import script from "./CbsSpinner.vue?vue&type=script&lang=js"
export * from "./CbsSpinner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4844acfd",
  null
  
)

export default component.exports